/**
 * Brands Listing Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/template-brands.liquid
 *
 */

import axios from 'axios';
import Collapsible from './collapsible.vue'

import { getBrandsListUrl } from '../utils/api';
import { getAllCollectionsGraphQL } from '../utils/helpers';

const API_URL = getBrandsListUrl();

export default {
    props: {
        excludedVendors: {
            type: String,
            default: ''
        },
        excludedCategories: {
            type: String,
            default: ''
        }
    },

    components: {
        Collapsible,
    },

    data() {
        return {
            brands: [],
            isLoading: true,
        }
    },

    computed: {
        excludedVendorsList() {
            if (!this.excludedVendors) return [];
            return this.excludedVendors.split(',').map(vendor => vendor.trim().toLowerCase()).filter(vendor => vendor.length > 0);
        },
        excludedCategoriesList() {
            if (!this.excludedCategories) return [];
            return this.excludedCategories.split(',').map(category => category.trim().toLowerCase()).filter(category => category.length > 0);
        }
    },

    mounted() {
        this._getBrandsData();
    },

    methods: {

        // Private
        _generateCollectionHandle(vendor, category) {
            const reformattedVendor = vendor.replaceAll(' ', '-').toLowerCase();
            const reformattedCategory = category.replaceAll(' ', '-').toLowerCase();

            return `${reformattedVendor}-${reformattedCategory}`;
        },
        _generateCollectionUrl(handle) {
            return `/collections/${handle}`;
        },

        _getBrandsData() {
            axios.get(API_URL)
                .then(({ data }) => {
                    this._parseBrandsData(data);
                }).catch((error) => {
                    console.log(error);
                });
        },

        async _parseBrandsData(data) {
            // Object.keys(data).find(key => {
            //     if (key.toLowerCase() === 'prescription app') {
            //         delete data[key]; 
            //     };
            // })
            /* 
                Ok this looks gross but its basically outputting all of the brands data into a nice format we can use.
                Using reduce a lot so we can output objects directly.

                - the categories are a lot cleaner than they were originally, which makes our life a lot easier; we can use the category names elsewhere than having to group things ourselves
                - group the vendors in a category alphabetically
                    - generate groups dynamically using object[key]
                    - then transform into happier objects using Object.entries to get the key and data separately

                {
                    category: [
                        {
                            group: alpha-character,
                            data: [
                                { 
                                    vendor: abcd,
                                    count: 123,
                                    url: google.com
                                }
                            ]
                        }
                    ]
                }
            */
            const collections = await getAllCollectionsGraphQL();

            this.brands = Object.entries(data).reduce((acc, category) => {
                let categoryName = category[0];

                // Check if category should be excluded
                let categoryNameLower = categoryName.toLowerCase();
                if (this.excludedCategoriesList.includes(categoryNameLower)) {
                    return acc; // Skip this entire category
                }

                let vendorsDataGrouped = Object.values(category[1]).reduce((acc, vendor) => {
                    // Check if vendor should be excluded
                    let vendorNameLower = vendor.vendor.toLowerCase();
                    // Skip if vendor is excluded
                    if (this.excludedVendorsList.includes(vendorNameLower)) return acc;

                    const collectionHandle = this._generateCollectionHandle(vendor.vendor, categoryName);

                    // Skip if collection does not exist
                    const collectionExists = collections.some(collection => collection.handle === collectionHandle);
                    if (!collectionExists) return acc;

                    let alphaKey = vendor.vendor.toLowerCase()[0];
                    return {
                        ...acc,
                        [`${alphaKey}`]: [
                            ...(acc[`${alphaKey}`] || []),
                            {
                                ...vendor,
                                url: this._generateCollectionUrl(collectionHandle)
                            }
                        ]
                    }
                }, {}),
                    vendorsDataFormatted = Object.entries(vendorsDataGrouped).map(dataset => {
                        return {
                            'group': dataset[0], // this is alphaKey from the previous step
                            'data': dataset[1] // array of all the vendor data objects
                        }
                    });
                return {
                    ...acc,
                    [categoryName]: vendorsDataFormatted
                }
            }, {});

            this.isLoading = false;
        }
    }
}